import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import {
    GET_GOOGLE_CREDENTIALS,
    DELETE_GOOGLE_CREDENTIALS,
    SET_GOOGLE_CREDENTIALS,
    CANCEL_QUERY,
    TOGGLE_INTEGRATION_UNCONFIGURED_DIALOG
} from './types.js';

export const INITIAL_STATE = {
    isLoading: false,
    googleCredentials: null,
    error: null,
    requestId: null,
    isIntegrationUnconfiguredDialogOpen: false
};

export const googleReducer = produce((draft, action) => {
    switch (action.type) {
        case GET_GOOGLE_CREDENTIALS.STARTED:
        case SET_GOOGLE_CREDENTIALS.STARTED:
        case DELETE_GOOGLE_CREDENTIALS.STARTED: {
            draft.error = null;
            draft.isLoading = true;
            draft.requestId = action.meta.requestId;
            break;
        }

        case GET_GOOGLE_CREDENTIALS.FAILED:
        case SET_GOOGLE_CREDENTIALS.FAILED:
        case DELETE_GOOGLE_CREDENTIALS.FAILED: {
            draft.error = extractError(action.payload);
            draft.googleCredentials = null;
            draft.isLoading = false;
            break;
        }
        case GET_GOOGLE_CREDENTIALS.SUCCEEDED: {
            draft.googleCredentials = action.payload;
            draft.isLoading = false;
            break;
        }
        case SET_GOOGLE_CREDENTIALS.SUCCEEDED: {
            draft.isLoading = false;
            break;
        }
        case DELETE_GOOGLE_CREDENTIALS.SUCCEEDED: {
            draft.googleCredentials = {};
            draft.error = null;
            draft.requestId = null;
            draft.isLoading = false;
            break;
        }
        case CANCEL_QUERY.SUCCEEDED: {
            return INITIAL_STATE;
        }
        case TOGGLE_INTEGRATION_UNCONFIGURED_DIALOG: {
            draft.isIntegrationUnconfiguredDialogOpen = action.isOpen;
            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
